module.exports = __webpack_public_path__ + "static/media/HCMM541.df6edd35.jpg";